'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var withMfsRoot = require('../files/utils/with-mfs-root.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var log = debug__default["default"]('ipfs:repo:gc');

function createGc(_ref) {
  var repo = _ref.repo,
      hashers = _ref.hashers;

  function gc() {
    return _gc.apply(this, arguments);
  }

  function _gc() {
    _gc = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          start,
          mfsRootCid,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              start = Date.now();
              _context.prev = 2;
              _context.next = 5;
              return _awaitAsyncGenerator(withMfsRoot.loadMfsRoot({
                repo: repo,
                hashers: hashers
              }, options));

            case 5:
              mfsRootCid = _context.sent;
              _context.next = 8;
              return _awaitAsyncGenerator(repo.pins.pinRecursively(mfsRootCid));

            case 8:
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(repo.gc()), _awaitAsyncGenerator), "t0", 9);

            case 9:
              _context.prev = 9;

              if (!mfsRootCid) {
                _context.next = 13;
                break;
              }

              _context.next = 13;
              return _awaitAsyncGenerator(repo.pins.unpin(mfsRootCid));

            case 13:
              return _context.finish(9);

            case 14:
              log("Complete (".concat(Date.now() - start, "ms)"));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2,, 9, 14]]);
    }));
    return _gc.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(gc);
}

exports.createGc = createGc;